import { InjectionToken } from '@angular/core';

export const TRADER_BASE_URL = new InjectionToken<string>('TRADER_BASE_URL');
